import { Camera, X } from "lucide-react";

/** Extra vehicle photos. The first photo is always sent as vehicleImage by the form. */
export default function AdditionalVehiclePhotos({ images, onAdd, onRemove, inputRef, disabled = false }) {
  return (
    <div className="mt-3" style={{ width: "100%" }}>
      <div className="flex items-center justify-between gap-2 mb-2">
        <span className="text-xs font-semibold text-slate-700">Additional vehicle photos (optional)</span>
        <span className="text-xs text-slate-500">{images.length}/2</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {images.map(({ url }, index) => (
          <div key={url} className="relative" style={{ width: 76, height: 76 }}>
            <img src={url} alt={`Additional vehicle ${index + 1}`} style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 10, border: "1px solid #dbeafe" }} />
            <button type="button" aria-label={`Remove additional vehicle photo ${index + 1}`} disabled={disabled}
              onClick={() => onRemove(index)}
              style={{ position: "absolute", right: -5, top: -5, borderRadius: "50%", background: "#182035", color: "white", padding: 4, border: 0, cursor: "pointer" }}><X size={12} /></button>
          </div>
        ))}
        {images.length < 2 && (
          <button type="button" disabled={disabled} onClick={() => inputRef.current?.click()}
            className="flex items-center justify-center gap-1 text-xs font-medium text-blue-600"
            style={{ minWidth: 76, height: 76, border: "1px dashed #8ecaff", borderRadius: 10, background: "#f8fbff", padding: 8, cursor: "pointer" }}>
            <Camera size={16} /> Add photo
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple hidden
        onChange={(event) => { onAdd(event.target.files); event.target.value = ""; }} />
      <p className="text-xs text-slate-500 mt-1">1 main VIN/Rego photo + up to 2 additional vehicle photos.</p>
    </div>
  );
}
